// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"253":"e1a8862e9b55b0c9","309":"cb03c29f9b7a4b69","478":"fc875b4b8b5b0f60","982":"c0355ad331e7bafb"}[chunkId] + ".js";
};